module.exports = __webpack_public_path__ + "img/t_noteup.e7896067.gif";